import { GLOBAL_BLOCK_UI, GLOBAL_RELEASE_UI } from "../constants";

const initial_state = {
  block_ui: false,
};

interface stateOptions {
  type: string;
  payload?: any;
}

export default function Globals(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case GLOBAL_BLOCK_UI:
      return {
        block_ui: true,
      };

    case GLOBAL_RELEASE_UI:
      return {
        block_ui: false,
      };

    default:
      return state;
  }
}
